<template>
  <div>
    <!-- Accès rapide (RGAA) : le header legacy porteur des skip-links est masqué pour les rôles Labricot -->
    <div class="fr-skiplinks">
      <nav class="fr-container" role="navigation" aria-label="Accès rapide">
        <ul class="fr-skiplinks__list no-bullets px-2">
          <li><a class="fr-link mr-2" href="#contenu">Contenu</a></li>
        </ul>
      </nav>
    </div>

    <!-- Barre fine supérieure : hamburger + logo (dégradé lavande repris de l'espace convive) -->
    <v-app-bar app dense height="56" class="labricot-appbar">
      <v-app-bar-nav-icon
        aria-label="Ouvrir le menu de navigation"
        :aria-expanded="String(drawer)"
        @click="drawer = !drawer"
      />
      <v-toolbar-title class="d-flex align-center">
        <img src="/static/images/logo-labricot-new.png" alt="Labricot" height="40" class="labricot-appbar__logo" />
      </v-toolbar-title>
    </v-app-bar>

    <!-- Drawer accordéon à gauche, fermé par défaut, ouverture au hamburger -->
    <v-navigation-drawer v-model="drawer" app temporary left width="280" class="labricot-drawer">
      <v-list nav dense aria-label="Navigation principale">
        <!-- Navigation inter-vues filtrée par rôle -->
        <v-list-item v-for="item in navItems" :key="item.title" :to="item.to" exact link @click="drawer = false">
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider class="my-2" />

        <!-- Informations légales (accordéon) -->
        <v-list-group prepend-icon="mdi-information-outline" no-action>
          <template #activator>
            <v-list-item-content>
              <v-list-item-title>Informations légales</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item v-for="link in legalLinks" :key="link.to" :to="link.to" exact link @click="drawer = false">
            <v-list-item-content>
              <v-list-item-title>{{ link.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-divider class="my-2" />

        <!-- Déconnexion -->
        <v-list-item link @click="confirmLogout = true">
          <v-list-item-icon>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Déconnexion</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <!-- Confirmation de déconnexion -->
    <v-dialog v-model="confirmLogout" max-width="420">
      <v-card>
        <v-card-title class="text-h6">Se déconnecter ?</v-card-title>
        <v-card-text>Vous allez être déconnecté de votre session Labricot.</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="confirmLogout = false">Annuler</v-btn>
          <v-btn color="primary" @click="logout">Se déconnecter</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "AppNavDrawer",

  data() {
    return {
      drawer: false,
      confirmLogout: false,
    }
  },

  computed: {
    job() {
      const user = this.$store.state.loggedUser
      return user ? user.job : null
    },

    contextCanteen() {
      return this.$store.getters.contextCanteen
    },

    navItems() {
      const items = []

      // Tableau de bord : cible = dashboard Labricot du rôle (navigation par chemin,
      // les noms de routes étant dupliqués dans le projet — cf. WorkerDashboard2).
      const dashboardByJob = {
        MANAGER: "/dashboard-manager3",
        WORKER: "/dashboard-worker2",
        SUPERVISOR: "/dashboard-supervisor5",
      }
      const dashboard = dashboardByJob[this.job]
      if (dashboard) {
        items.push({ title: "Tableau de bord", icon: "mdi-view-dashboard-outline", to: dashboard })
      }

      // Modifier ma cantine : manager uniquement, lien canonique id--nom depuis la cantine de contexte.
      if (this.job === "MANAGER" && this.contextCanteen) {
        const { id, name } = this.contextCanteen
        items.push({
          title: "Modifier ma cantine",
          icon: "mdi-pencil-outline",
          to: { name: "CanteenForm", params: { canteenUrlComponent: `${id}--${name || ""}` } },
        })
      }

      return items
    },

    legalLinks() {
      // Chemins en dur (noms de routes dupliqués entre la nav principale et /v2).
      return [
        { title: "Mentions légales", to: "/mentions-legales" },
        { title: "CGU", to: "/cgu" },
        { title: "Politique de confidentialité", to: "/politique-de-confidentialite" },
        { title: "Accessibilité", to: "/accessibilite" },
        { title: "Plan du site", to: "/plan-du-site/" },
      ]
    },
  },

  methods: {
    logout() {
      this.confirmLogout = false
      this.drawer = false
      this.$store.dispatch("logout")
    },
  },
}
</script>

<style scoped>
/* Dégradé lavande repris du hero de l'espace convive (color prop Vuetify n'accepte pas les dégradés) */
.labricot-appbar >>> .v-toolbar__content {
  background: linear-gradient(135deg, #f5f3ff 0%, #ede9ff 60%, #e4dfff 100%);
}
.labricot-appbar__logo {
  display: block;
  max-height: 40px;
  width: auto;
}
</style>
